/**
 * Scenarios API Service
 */

import { api } from './api';
import type {
  ListScenariosResponse,
  GetScenarioResponse,
} from '../types/api';

export const scenariosApi = {
  /**
   * List scenarios for a project with multi-select filters and search.
   */
  list: async (
    projectId: string,
    params?: {
      status?: string | string[];
      domain?: string | string[];
      area?: string | string[];
      search?: string;
    },
  ): Promise<ListScenariosResponse> => {
    const queryParams = new URLSearchParams();
    const appendMulti = (key: string, v: string | string[] | undefined) => {
      if (v == null) return;
      if (Array.isArray(v)) {
        for (const item of v) queryParams.append(key, item);
      } else {
        queryParams.set(key, v);
      }
    };

    appendMulti('status', params?.status);
    appendMulti('domain', params?.domain);
    appendMulti('area', params?.area);
    if (params?.search) queryParams.set('search', params.search);

    const query = queryParams.toString();
    const endpoint = query
      ? `/admin/projects/${projectId}/scenarios?${query}`
      : `/admin/projects/${projectId}/scenarios`;

    return api.get<ListScenariosResponse>(endpoint);
  },

  /**
   * Get scenario details with steps
   */
  get: async (scenarioId: string): Promise<GetScenarioResponse> => {
    return api.get<GetScenarioResponse>(`/admin/scenarios/${scenarioId}`);
  },

  /**
   * Mark scenario as ready for execution
   */
  execute: async (scenarioId: string): Promise<{ message: string }> => {
    return api.post<{ message: string }>(`/admin/scenarios/${scenarioId}/execute`);
  },

  /**
   * Mark scenario as complete
   */
  complete: async (scenarioId: string): Promise<{ message: string }> => {
    return api.post<{ message: string }>(`/admin/scenarios/${scenarioId}/complete`);
  },
};
